import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { MediaObjectQuality, MediaObjectType } from '../types/media';
import {
    useClipMediaResolver,
    UseClipMediaResolverArgs,
} from './useClipMediaResolver';
import { useSelectedClip } from './useSelectedClipSelectors';

export const useSelectedClipMediaResolver = (
    type: MediaObjectType,
    qualityOverride?: MediaObjectQuality,
) => {
    const { selectedClip } = useSelectedClip();

    const queryArgs: SkipOrArgs<UseClipMediaResolverArgs> = useMemo(() => {
        if (
            !selectedClip ||
            !selectedClip.mediaObjectId ||
            !selectedClip.mediaIdentifiers?.[type]
        ) {
            return skipToken;
        }

        const availableItems = selectedClip.mediaIdentifiers[type];

        const bestAvailableMOI = qualityOverride
            ? availableItems[qualityOverride]
            : availableItems.HIGH ||
              availableItems.MEDIUM ||
              availableItems.LOW;

        if (!bestAvailableMOI?.id) return skipToken;

        return {
            mediaObjectId: selectedClip.mediaObjectId,
            moiId: bestAvailableMOI.id,
        };
    }, [qualityOverride, selectedClip, type]);

    return useClipMediaResolver(queryArgs);
};
